import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppService } from '../../app.service';
import { DataCheckService } from '../services/data-check.service';

export const protectGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const appService = inject(AppService);
  const dataCheckService = inject(DataCheckService);

  const userData = appService.getUserData();
  const isSuperUser = dataCheckService.isSuperUser();
  const isPrimeContractorUser = dataCheckService.isPrimeContractorUser();
  const isUserAdmin = dataCheckService.isUserAdmin();
  const isDispatchUser = dataCheckService.isDispatchUser();
  const isGuardUser = dataCheckService.isGuardUser();
  const appRoutesConfig: any = dataCheckService.getAppRouteConfig();

  if (userData?.access) {
    const routePath = route.url?.[0]?.path;

    // Super User access control
    if (isSuperUser) {
      if (routePath === 'gtadmin' || !route.url?.length) {
        setTimeout(() => {
          const statePaths = state.url.split('/')?.filter((item: any) => item);
          const alreadyInAdminRoute = statePaths?.length
            ? statePaths[0] === 'gtadmin'
            : false;

          // set time out added to avoid infinite redirecitons
          if (!route.url?.length && !alreadyInAdminRoute) {
            router.navigate(['/gtadmin/dashboard']);
          }
        }, 500);

        return true;
      } else {
        router.navigate(['404']);
        return false;
      }
    } else if (isPrimeContractorUser) {
      if (routePath === 'gtadmin') {
        router.navigate(['404']);
        return false;
      } else {
        setTimeout(() => {
          const statePaths = state.url.split('/')?.filter((item: any) => item);
          const alreadyInAdminRoute = statePaths?.length
            ? statePaths[0] === 'pc'
            : false;

          // set time out added to avoid infinite redirecitons
          if (!route.url?.length && !alreadyInAdminRoute) {
            router.navigate(['/pc']);
          }
        }, 500);
        return true;
      }
    }
    // Normal User access control
    else {
      if (routePath === 'gtadmin') {
        router.navigate(['404']);
        return false;
      } else {
        if (isUserAdmin || !routePath || routePath === 'dashboard') {
          // no routpath means home page allow it; also allow if its a manager
          return true;
        }
        if (isDispatchUser || isGuardUser) {
          const updatedRoutePath = `/${routePath}`;
          if (
            appRoutesConfig?.all_routes?.includes(updatedRoutePath) &&
            !appRoutesConfig?.allowed_routes?.includes(updatedRoutePath)
          ) {
            router.navigate(['404']);
            return false;
          }
        }
        return true;
      }
    }
  } else {
    router.navigate(['./login']);
    return false;
  }
};
